import axios from "axios";
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;
const api_token = localStorage.getItem('authUser');

//* SEND EMAIL ADDRESS -
export const sendEmailOTPAPI = async (payload) => {
    let obj = JSON.parse(localStorage.getItem("authUser"))
    console.log("calling sendEmailOTPAPI" + obj)

    console.log(payload)
    const headers = {
        "Content-Type": "application/json",
        Authorization: `${obj}`,
        "Accept": "*",
    };
    return await axios.post(`${apiBaseUrl}/send-email-otp`, payload.payload, {
        headers,
    });
};

//VERIFY OTP
export const verifyEmailOTPAPI = async (payload) => {
    let obj = JSON.parse(localStorage.getItem("authUser"))
    console.log(payload)
    const headers = {
        "Content-Type": "application/json",
        Authorization: `${obj}`,
        "Accept": "*",
    };
    return await axios.post(`${apiBaseUrl}/verify-email-otp`, payload.payload, {
        headers,
    });
};

export const updateNewEmailAPI = async (payload) => {
    let obj = JSON.parse(localStorage.getItem("authUser"))
    console.log(payload)
    const headers = {
        "Content-Type": "application/json",
        Authorization: `${obj}`,
        "Accept": "*",
    };
    return await axios.post(`${apiBaseUrl}/newUserEmail`, payload, {
        headers,
    });
};